import styled from 'styled-components';

export const Image = styled.img`
  
  border-radius: 50%;
  user-select: none;
  object-fit: cover;

  &.chat {
    width: 4rem;
    height: 4rem;
  }

  &.small {
    width: 2.4rem;
    height: 2.4rem;
  }

  &.userInfo {
    width: 6rem;
    height: 6rem;
  }

  &.middle {
    width: 6.6rem;
    height: 6.6rem;
  }

  &.large {
    width: 8.2rem;
    height: 8.2rem;
  }

`;